export { default as ResultadosReport } from './Report'
